import { useContext } from "react";
import { Context } from "../../context/context";
import { Link } from "react-router-dom";
import {
  FaFileDownload,
  // FaFileUpload,
  FaSignOutAlt,
  FaMapMarked,
  FaPoll,
  FaPollH,
} from "react-icons/fa";

import "./Dashboard.scss";

export default function Dashboard() {
  const { sidebar } = useContext(Context);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Dashboard</h1>
        <div className="cards-container">
          <Link to="/dashboard/csv">
            <div>
              <FaFileDownload />
            </div>
            <p className="text">Csv</p>
          </Link>
          <Link to="/dashboard/volume-zona">
            <div>
              <FaPoll />
            </div>
            <p className="text">Volume perdido por zona</p>
          </Link>
          <Link to="/dashboard/volume-cidade">
            <div>
              <FaPollH />
            </div>
            <p className="text">Volume perdido por cidade</p>
          </Link>
          <Link to="/dashboard/volume-empresa">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Volume perdido por empresa</p>
          </Link>
          <Link to="/dashboard/volume-produto">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Volume perdido por produto</p>
          </Link>
          <Link to="/dashboard/volume-covep">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Volume perdido por covep</p>
          </Link>
          <Link to="/dashboard/volume-concorrente">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Volume perdido por concorrente</p>
          </Link>
          <Link to="/dashboard/volume-usuario">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Volume perdido por usuário</p>
          </Link>
          {/* <Link to="/cadastro/excel">
            <div>
              <FaFileUpload />
            </div>
            <p className="text">Upload Excel</p>
          </Link> */}
          {/* <Link to="/cadastro/concorrentes">
            <div>
              <FaSignOutAlt />
            </div>
            <p className="text">Concorrentes</p>
          </Link>
          <Link to="/cadastro/zonas-venda">
            <div>
              <FaMapMarked />
            </div>
            <p className="text">Zona de Venda</p>
          </Link> */}
        </div>
      </main>
    </>
  );
}
